import { getUserRoles } from '@infra/auth';
import type { PortalKey } from '@services/access';
import { USER_ROLE_CLAIMS } from '@shared/constants';
import { accountPaths } from '../model/account-paths';
import { usePortalScope } from './PortalScope';

/** Account page paths of the portal the current route belongs to. */
export function useAccountPaths() {
  const { key } = usePortalScope();
  const isAdmin = getUserRoles().includes(USER_ROLE_CLAIMS.ADMIN);
  return accountPaths(isAdmin ? 'admin' : (key as PortalKey));
}
